"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatPhoneNumber = exports.formatPercentage = exports.formatMoney = void 0;

var _accounting = _interopRequireDefault(require("accounting"));

var formatMoney = function formatMoney(v) {
  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return _accounting["default"].formatMoney(v, null, precision);
};

exports.formatMoney = formatMoney;

var formatPercentage = function formatPercentage(v) {
  var multiplier = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  var precision = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;
  return "".concat(_accounting["default"].formatNumber(v * multiplier, precision), "%");
};

exports.formatPercentage = formatPercentage;

var formatPhoneNumber = function formatPhoneNumber(v) {
  if (!v) return v;
  return v.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
};

exports.formatPhoneNumber = formatPhoneNumber;